<template>
  <div class="profile-card">
    <div class="profile-avatar-section">
      <div class="profile-avatar" @click="dialogVisible = true">
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <div class="avatar-edit-mask">
          <i class="el-icon-camera"></i>
        </div>
      </div>
      <div class="profile-username">{{ form.name }}</div>
    </div>
    <div
      class="profile-user-type-card"
      :class="form.vip ? 'profile-vip' : 'profile-normal'"
    >
      <div class="user-type-icon">
        <i v-if="form.vip" class="el-icon-s-flag"></i>
        <i v-else class="el-icon-user-solid"></i>
      </div>
      <div class="user-type-info">
        <div class="user-type-title">
          {{ form.vip ? "高校会员用户" : "普通用户" }}
        </div>
        <div class="user-type-desc">
          <template v-if="form.vip">
            <span>享有高校专属资源、免费下载等特权。</span>
          </template>
          <template v-else>
            <span>可浏览公开资源，升级会员享更多权益。</span>
          </template>
        </div>
      </div>
    </div>
    <div class="profile-info-list">
      <div class="profile-info-item">
        <i class="el-icon-mobile-phone"></i>
        <span>手机号</span>
        <strong>{{ form.account }}</strong>
      </div>
      <div class="profile-info-item">
        <i class="el-icon-date"></i>
        <span>注册时间</span>
        <strong class="profile-date">{{ formatDate(form.time) }}</strong>
      </div>
      <div class="profile-info-item profile-info-editable">
        <i class="el-icon-user"></i>
        <span>用户名</span>
        <div v-if="istrue == 1" class="profile-edit-display">
          <strong>{{ form.name }}</strong>
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="valBox"
          ></el-button>
        </div>
        <div v-else class="profile-edit-form">
          <el-input
            v-model="value"
            size="small"
            maxlength="16"
            placeholder="请输入用户名"
            style="width: 160px;"
          />
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            @click="rightBox"
          ></el-button>
          <el-button
            type="text"
            icon="el-icon-close"
            size="small"
            @click="wrong"
          ></el-button>
          <span class="profile-edit-error">{{ msg }}</span>
        </div>
      </div>
    </div>
    <!-- 头像弹窗 -->
    <div class="member_Popup">
      <el-dialog
        title="编辑头像"
        :visible.sync="dialogVisible"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="600px"
      >
        <div style="display: flex" class="avatar">
          <div class="avatar-left">
            <div v-show="!options.img">
              <el-upload
                ref="upload"
                :action="uploadimage"
                style="text-align: center;margin-bottom: 24px"
                :on-change="uploads"
                accept="image/png, image/jpeg, image/jpg"
                :show-file-list="false"
                :auto-upload="false"
              >
                <el-button
                  slot="trigger"
                  size="small"
                  type="primary"
                  ref="uploadBtn"
                  >选择图片</el-button
                >
              </el-upload>
              <div>支持jpg、png格式的图片，大小不超过3M</div>
            </div>
            <div v-show="options.img" class="avatar-left-crop">
              <vueCropper
                class="crop-box"
                ref="cropper"
                :img="options.img"
                :autoCrop="options.autoCrop"
                :fixedBox="options.fixedBox"
                :canMoveBox="options.canMoveBox"
                :autoCropWidth="options.autoCropWidth"
                :autoCropHeight="options.autoCropHeight"
                :centerBox="options.centerBox"
                @realTime="realTime"
              ></vueCropper>
              <p class="avatar-left-p">
                鼠标滚轮缩放控制图片显示大小，鼠标拖拽调整显示位置
              </p>
            </div>
          </div>
          <div class="avatar-right">
            <div
              class="avatar-right-div"
              v-for="(item, index) in previewsDiv"
              :key="index"
              :style="item.style"
            >
              <div
                v-show="options.img"
                :class="previews.div"
                class="avatar-right-previews"
                :style="item.zoomStyle"
              >
                <img :src="previews.url" :style="previews.img" />
              </div>
            </div>
            <div class="avatar-right-text">
              <el-button v-if="options.img" type="text" @click="uploadPreviews"
                >重新上传</el-button
              >
              <span v-else>预览</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="getCrop">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { isAdminLoggedIn } from '@/utils/adminAuth';

export default {
  data() {
    return {
      istrue: 1,
      msg: "",
      value: "",
      form: {},
      uploadimage: "",
      imageUrl: "",
      dialogVisible: false,
      options: {
        img: "", //原图文件
        autoCrop: true, //默认生成截图框
        fixedBox: true, //固定截图框大小
        canMoveBox: false, //截图框不能拖动
        autoCropWidth: 200, //截图框宽度
        autoCropHeight: 200, //截图框高度
        centerBox: true //截图框被限制在图片里面
      },
      //实时预览图数据
      previews: {},
      //实时预览图样式
      previewsDiv: [
        //108px 预览样式
        {
          style: {
            width: "108px",
            height: "108px",
            margin: "0 auto"
          },
          zoomStyle: {
            transform: "scale(0.54,0.54)",
            transformOrigin: "top left"
          }
        },
        //68px 预览样式
        {
          style: {
            width: "68px",
            height: "68px",
            margin: "27px auto"
          },
          zoomStyle: {
            transform: "scale(0.34,0.34)",
            transformOrigin: "top left"
          }
        },
        //48px 预览样式
        {
          style: {
            width: "48px",
            height: "48px",
            margin: "0 auto"
          },
          zoomStyle: {
            transform: "scale(0.24,0.24)",
            transformOrigin: "top left"
          }
        }
      ]
    };
  },
  methods: {
    async getapp() {
      this.imageUrl = this.$store.state.avatar;
      this.uploadimage = this.$store.state.uploadimage;
      
      try {
        // 使用统一的API调用工具
        const userInfo = await this.getUserInfo();
        if (userInfo) {
          this.form = userInfo;
        }
      } catch (error) {
        console.error('获取用户个人信息失败:', error);
        // 如果API调用失败，尝试从store中获取基本信息
        this.form = {
          name: this.$store.state.userName || '',
          account: this.$store.state.account || '',
          avatar: this.$store.state.avatar || '',
          vip: this.$store.state.vip || false,
          vipName: this.$store.state.vipName || '',
          vipDate: this.$store.state.vipDate || '',
          time: new Date().toISOString()
        };
      }
    },
    
    // 获取用户信息（统一处理admin和普通用户）
    async getUserInfo() {
      // 检测admin登录状态：优先检查localStorage，然后检查store中的权限
      const isAdmin = isAdminLoggedIn() || 
                     (this.$store.state.canFileManage || this.$store.state.canUserManage || this.$store.state.canSystemManage);
      
      if (isAdmin) {
        // admin用户使用admin接口
        try {
          const response = await this.axios.getAdminCurrentUser();
          if (response.data && response.data.code === 200) {
            const userInfo = response.data.data;
            return {
              name: userInfo.name || userInfo.username || '',
              account: userInfo.account || userInfo.username || userInfo.mobile || '',
              avatar: userInfo.avatar || '',
              vip: userInfo.vip || false,
              vipName: userInfo.vipName || '',
              vipDate: userInfo.vipDate || '',
              time: userInfo.createTime || new Date().toISOString()
            };
          }
        } catch (error) {
          console.error('admin用户获取个人信息失败:', error);
          throw error;
        }
      } else {
        // 普通用户使用普通接口
        try {
          const response = await this.axios.myinfo({
            token: this.$store.state.token
          });
          if (response.data && response.data.code === 200) {
            const data = response.data.data;
            // 后端/base接口只返回部分字段，需要从store中补充其他字段
            return {
              name: data.name || this.$store.state.userName || '',
              account: this.$store.state.account || '',
              avatar: this.$store.state.avatar || '',
              vip: this.$store.state.vip || false,
              vipName: this.$store.state.vipName || '',
              vipDate: this.$store.state.vipDate || '',
              time: new Date().toISOString() // 后端没有返回注册时间
            };
          }
        } catch (error) {
          console.error('普通用户获取个人信息失败:', error);
          throw error;
        }
      }
      
      return null;
    },
    formatDate(val) {
      if (!val) return "";
      return val.toString().slice(0, 10);
    },
    valBox() {
      this.value = this.form.name;
      this.istrue = 0;
    },
    rightBox() {
      if (this.value == "") {
        this.msg = "请输入值";
      } else if (this.value.length > 16) {
        this.msg = "不超过16个字符";
      } else {
        this.axios
          .myupdate({
            token: this.$store.state.token,
            name: this.value
          })
          .then(res => {
            if (res.data.code == 200) {
              // 更新store中的用户名
              const newName = res.data.data.name || this.value;
              this.$store.dispatch("userName", {
                value: newName,
                remember: true
              });
              // 更新本地form数据
              this.form.name = newName;
              this.istrue = 1;
              this.$message.success('用户名修改成功');
              
              // 强制更新header显示
              this.$nextTick(() => {
                // 触发store更新事件
                this.$store.commit('userName', { value: newName, remember: true });
              });
            } else {
              this.$message.info(res.data.message);
            }
          })
          .catch(err => {});
      }
    },
    wrong() {
      this.istrue = 1;
    },
    //读取原图
    uploads(file) {
      const isIMAGE =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt3M = file.raw.size / 1024 / 1024 < 3;
      if (!isIMAGE) {
        this.$message({
          showClose: true,
          message: "请选择 jpg、png 格式的图片！",
          type: "error" //提示类型
        });
        return false;
      }
      if (!isLt3M) {
        this.$message({
          showClose: true,
          message: "上传图片大小不能超过 3MB",
          type: "error" //提示类型
        });
        return false;
      }
      let data = window.URL.createObjectURL(new Blob([file.raw]));
      this.fileName = file.name;
      this.options.img = data;
    },
    //实时预览数据
    realTime(data) {
      this.previews = data;
    },
    //重新上传
    uploadPreviews() {
      this.$refs.uploadBtn.$el.click();
    },
    //获取截图信息
    getCrop() {
      // 获取截图的 base64 数据
      let formData = new FormData();
      this.$refs.cropper.getCropBlob(data => {
        formData.append("file", data, this.fileName);
        formData.append("token", this.$store.state.token);
        axios
          .post(this.uploadimage, formData)
          .then(res => {
            if (res.data.code == 200) {
              this.axios
                .myupdate({
                  token: this.$store.state.token,
                  avatar: res.data.data
                })
                .then(res => {
                  if (res.data.code == 200) {
                    this.$store.dispatch("avatar", res.data.data.avatar);
                    this.getapp();
                    this.dialogVisible = false;
                  }
                })
                .catch(err => {});
            }
          })
          .catch(err => {});
        // this.imageUrl = data
        // this.dialogVisible = false
      });
    },
    //关闭弹框
    closeDialog() {
      this.dialogVisible = false;
      //重置 data 数据。(Object.assign是对象深复制  this.$data是组件内的数据对象 this.$options.data()是原始的数据)
      Object.assign(this.$data, this.$options.data());
      this.getapp();
    }
  },
  mounted() {
    this.getapp();
  }
};
</script>
<style scoped>
.profile-card {
  max-width: 500px;
  margin: 40px auto 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 32px 24px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.profile-avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}
.profile-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(241, 120, 127, 0.1);
  position: relative;
  cursor: pointer;
  margin-bottom: 12px;
  background: #f5f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-avatar img.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.avatar-edit-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.18);
  color: #fff;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  border-radius: 50%;
  transition: opacity 0.2s;
}
.profile-avatar:hover .avatar-edit-mask {
  opacity: 1;
}
.profile-username {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin-bottom: 4px;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.profile-user-type {
  font-size: 14px;
  color: #f1787f;
  display: flex;
  align-items: center;
  gap: 4px;
}
.profile-info-list {
  width: 100%;
  margin-top: 8px;
  border-top: 1px solid #f3f3f3;
}
.profile-info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 0 10px 0;
  border-bottom: 1px solid #f3f3f3;
  font-size: 15px;
  color: #444;
  position: relative;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.profile-info-item:last-child {
  border-bottom: none;
}
.profile-info-item i {
  color: #f1787f;
  font-size: 18px;
  min-width: 20px;
}
.profile-info-item strong {
  margin-left: auto;
  font-weight: 600;
  color: #222;
  font-size: 15px;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  letter-spacing: 0.5px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.profile-info-editable .profile-edit-display {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}
.profile-info-editable .profile-edit-form {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}
.profile-edit-error {
  color: #f13640;
  font-size: 12px;
  margin-left: 8px;
}
.profile-user-type-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  margin-top: 0;
  padding: 18px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(241, 120, 127, 0.06);
  background: #f8f8fa;
  border: 1.5px solid #f3f3f3;
  transition: background 0.2s, border 0.2s;
}
.profile-user-type-card .user-type-icon {
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f3f3f3;
  color: #bbb;
  margin-right: 8px;
}
.profile-user-type-card .user-type-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.profile-user-type-card .user-type-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 2px;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.profile-user-type-card .user-type-desc {
  font-size: 14px;
  color: #888;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.profile-user-type-card.profile-vip {
  background: linear-gradient(90deg, #ffe7e7 0%, #fff6e7 100%);
  border: 1.5px solid #f1787f;
}
.profile-user-type-card.profile-vip .user-type-icon {
  background: #f1787f;
  color: #fff;
}
.profile-user-type-card.profile-vip .user-type-title {
  color: #f1787f;
}
.profile-user-type-card.profile-normal {
  background: #f8f8fa;
  border: 1.5px solid #e0e0e0;
}
.profile-user-type-card.profile-normal .user-type-icon {
  background: #e0e0e0;
  color: #bbb;
}
.profile-user-type-card.profile-normal .user-type-title {
  color: #888;
}
.profile-date {
  color: #f1787f;
  font-weight: 600;
  letter-spacing: 1px;
  font-family: "Arial", "Helvetica Neue", "Helvetica", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (max-width: 600px) {
  .profile-card {
    padding: 16px 4px 16px 4px;
    max-width: 98vw;
  }
}
</style>
<style>
.member_Popup .el-dialog__header {
  padding: 24px 0 11px 28px;
}
.member_Popup .el-dialog__title {
  color: #333333;
}
.member_Popup .el-dialog__body {
  padding: 0 28px;
}
.member_Popup .el-dialog__footer {
  padding: 20px 28px;
}
.member_Popup .el-button {
  width: 145px;
}
.member_Popup .avatar {
  display: flex;
}
.member_Popup .avatar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 400px;
  height: 400px;
  background-color: #f0f2f5;
  margin-right: 10px;
  border-radius: 4px;
}
.member_Popup .avatar-left-crop {
  width: 400px;
  height: 400px;
  position: relative;
}
.member_Popup .crop-box {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
}
.member_Popup .avatar-left-p {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 20px;
  color: #ffffff;
  font-size: 14px;
}
.member_Popup .avatar-right {
  width: 150px;
  height: 400px;
  background-color: #f0f2f5;
  border-radius: 4px;
  padding: 16px 0;
  box-sizing: border-box;
}
.member_Popup .avatar-right-div {
  border: 3px solid #ffffff;
  border-radius: 50%;
}

.member_Popup .avatar-right-previews {
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}
.member_Popup .avatar-right-text {
  text-align: center;
  margin-top: 50px;
  font-size: 14px;
}
.member_Popup .avatar-right-text span {
  color: #666666;
}
</style>

